// extracted by mini-css-extract-plugin
module.exports = {"container":"IPCAlert_container__11heg","wrap":"IPCAlert_wrap__2mAxO","sub":"IPCAlert_sub__F17Gd","content":"IPCAlert_content__1mol9"};